var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(199 307)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4759",
    "data-name": "Mask Group 4759",
    transform: "translate(-199 -307)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Insurance_1_",
    transform: "translate(147.047 289.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7335",
    "data-name": "Path 7335",
    d: "M180.7,178.269h-3.135A1.567,1.567,0,0,1,176,176.7v-3.135A1.567,1.567,0,0,1,177.567,172H180.7a1.567,1.567,0,0,1,1.567,1.567V176.7A1.567,1.567,0,0,1,180.7,178.269Z",
    transform: "translate(-115.298 -146.044)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_517",
    "data-name": "Line 517",
    y2: 1.061,
    transform: "translate(63.837 27.124)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M71.673,24.489a1.614,1.614,0,0,0-1.237-1.528C68.095,22.3,66.459,20,63.836,20s-4.259,2.3-6.6,2.961A1.614,1.614,0,0,0,56,24.489v4.45a9.748,9.748,0,0,0,7.836,9.551,9.748,9.748,0,0,0,7.836-9.551v-1.1",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionactive);
export default __webpack_public_path__ + "static/media/permissionactive.c82283932b6a383a4272fcf7bd238158.svg";
export { ForwardRef as ReactComponent };